import { createInitialStates, createResourceNames, createSequenceTypes, getErrorData } from '../helpers'
import { INITIAL_STATE_REDUCERS } from '../constants'

const RESOURCES = ['selectedUserActivitiesPermissionsGet', 'userActivitiesPermissionsByEntityGet', 'userByIdGet']
const R = createResourceNames(RESOURCES)
const TYPES = createSequenceTypes([
  'SELECTED_USER_ACTIVITIES_PERMISSIONS_GET',
  'USER_ACTIVITIES_PERMISSIONS_BY_ENTITY_GET',
  'USER_BY_ID_GET'
])
export const INITIAL_STATE = {
  ...createInitialStates(RESOURCES, INITIAL_STATE_REDUCERS)
}

const reducers = {
  // SELECTED USER ACTIVITIES PERMISSIONS GET ··········································································
  [TYPES.SELECTED_USER_ACTIVITIES_PERMISSIONS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.selectedUserActivitiesPermissionsGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.SELECTED_USER_ACTIVITIES_PERMISSIONS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ data: { ...payload.data }, status: payload.status }]
    return { ...state, [R.selectedUserActivitiesPermissionsGet]: { data, error: {}, isLoading: false } }
  },
  [TYPES.SELECTED_USER_ACTIVITIES_PERMISSIONS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return { ...state, [R.selectedUserActivitiesPermissionsGet]: { data: [], error, isLoading: false } }
  },
  [TYPES.SELECTED_USER_ACTIVITIES_PERMISSIONS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.selectedUserActivitiesPermissionsGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // USER ACTIVITIES PERMISSIONS BY ENTITY GET ································
  [TYPES.USER_ACTIVITIES_PERMISSIONS_BY_ENTITY_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.userActivitiesPermissionsByEntityGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.USER_ACTIVITIES_PERMISSIONS_BY_ENTITY_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ data: { ...payload.data }, status: payload.status }]
    return { ...state, [R.userActivitiesPermissionsByEntityGet]: { data, error: {}, isLoading: false } }
  },
  [TYPES.USER_ACTIVITIES_PERMISSIONS_BY_ENTITY_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return { ...state, [R.userActivitiesPermissionsByEntityGet]: { data: [], error, isLoading: false } }
  },
  [TYPES.USER_ACTIVITIES_PERMISSIONS_BY_ENTITY_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.userActivitiesPermissionsByEntityGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // USER BY ID GET ····························································
  [TYPES.USER_BY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.userByIdGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.USER_BY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ data: { ...payload.data }, status: payload.status }]
    return { ...state, [R.userByIdGet]: { data, error: {}, isLoading: false } }
  },
  [TYPES.USER_BY_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return { ...state, [R.userByIdGet]: { data: [], error, isLoading: false } }
  },
  [TYPES.USER_BY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.userByIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  }
}

export default reducers
